/**
 * * @module pages/news.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import Filter from "../components/filter";

const News = Backbone.View.extend({
  el: $(document),

  events: {
    // "click .news-show-more": "showMoreTags",
  },

  initialize: function () {
    this.render();
  },

  render: function () {
    this.filter = new Filter(
      ".all-news-list .page-block",
      ".child-pages.content-block"
    );
  },
});

export default News;
